<template>
  <div>
    <FormItem label="单位名称：" prop="companyName">
      <Input v-model="formInvoice.companyName"></Input>
    </FormItem>
    <FormItem label="纳税人识别号：" prop="dutyNo">
      <Input v-model="formInvoice.dutyNo"></Input>
    </FormItem>
    <FormItem label="购买方地址：" prop="buyerAddress">
      <Input v-model="formInvoice.buyerAddress"></Input>
    </FormItem>
    <FormItem label="购买方电话：" prop="buyerPhone">
      <Input v-model="formInvoice.buyerPhone"></Input>
    </FormItem>
    <FormItem label="银行名称：" prop="buyerBankName">
      <Input v-model="formInvoice.buyerBankName"></Input>
    </FormItem>
    <FormItem label="银行账号：" prop="buyerBankAccount">
      <Input v-model="formInvoice.buyerBankAccount"></Input>
    </FormItem>
  </div>
</template>

<script>
export default {
  props: ['formInvoice'],
  watch: {
    'formInvoice.dutyNo': {
      handler(newVal) {
        if (newVal) {
          // 去除所有空格
          this.formInvoice.dutyNo = newVal.replace(/\s/g, '').toUpperCase();
        }
      }
    }
  }
};
</script>

<!-- 样式 -->
<style scoped>
:deep(.ivu-form-item-label) {
  white-space: nowrap;
}
</style>
